(function(){
  if (window.__axSite) return;
  window.__axSite = 1;

  var SEC   = 'cart-drawer-section';
  var WRAP  = 'shopify-section-cart-drawer-section';
  var COUNTS = '.cart-bubble__text-count, [data-cart-count], .cart-count, .cart-count-bubble, .theme-drawer__badge';
  var BUBBLES = '.cart-bubble, .cart-bubble__text-count, [data-cart-count], .cart-count, .cart-count-bubble, .theme-drawer__badge';
  var ICONS  = ['#cart-icon-bubble','.header__cart','[data-cart-drawer-opener]','button[aria-controls*="cart"]','[class*="cart-bubble"]','.axbn a[href="/cart"]'];

  function q(s, r){ try { return (r || document).querySelector(s); } catch(e){ return null; } }
  function spin(el){ if (window.axSpin) window.axSpin(el); }
  function unspin(el){ if (window.axUnspin) window.axUnspin(el); }
  function reduced(){
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch(e){ return false; }
  }
  function phone(){
    try { return window.matchMedia('(max-width: 749px)').matches; } catch(e){ return window.innerWidth <= 749; }
  }
  function onCartPage(){
    var p = window.location.pathname || '';
    return p === '/cart' || p.indexOf('/cart/') === 0;
  }

  function cartIcon(){
    for (var i=0;i<ICONS.length;i++){
      var els = document.querySelectorAll(ICONS[i]);
      for (var j=0;j<els.length;j++){
        var r = els[j].getBoundingClientRect();
        if (r.width > 0 && r.height > 0 && r.top >= -40) return els[j];
      }
    }
    return null;
  }
  function pulse(el){
    try { el.animate([{transform:'scale(1)'},{transform:'scale(1.3)'},{transform:'scale(1)'}],{duration:430,easing:'cubic-bezier(.34,1.56,.64,1)'}); } catch(e){}
  }

  function flyToCart(btn){
    if (reduced()) return;
    try {
      var card = btn.closest('.ax-card') || btn.closest('li') || btn.parentElement;
      var img = card && card.querySelector('img');
      var target = cartIcon();
      if (!img || !target || typeof img.animate !== 'function') return;
      var s = img.getBoundingClientRect();
      var t = target.getBoundingClientRect();
      if (!s.width || !t.width) return;
      var fly = document.createElement('img');
      fly.src = img.currentSrc || img.src;
      fly.alt = '';
      fly.setAttribute('aria-hidden','true');
      fly.style.cssText = 'position:fixed;left:' + s.left + 'px;top:' + s.top + 'px;width:' + s.width +
        'px;height:' + s.height + 'px;object-fit:contain;background:#fff;border-radius:12px;' +
        'box-shadow:0 18px 40px rgba(0,0,0,.35);z-index:2147483002;pointer-events:none;will-change:transform,opacity';
      document.body.appendChild(fly);
      var dx = (t.left + t.width/2) - (s.left + s.width/2);
      var dy = (t.top + t.height/2) - (s.top + s.height/2);
      var a = fly.animate([
        { transform:'translate(0,0) scale(1)', opacity:1, offset:0 },
        { transform:'translate(' + (dx*0.45) + 'px,' + (dy*0.45 - 90) + 'px) scale(.5)', opacity:.95, offset:.55 },
        { transform:'translate(' + dx + 'px,' + dy + 'px) scale(.08)', opacity:.2, offset:1 }
      ], { duration: 620, easing: 'cubic-bezier(.42,0,.28,1)', fill: 'forwards' });
      a.onfinish = function(){ if (fly.parentNode) fly.remove(); pulse(target); };
      setTimeout(function(){ if (fly.parentNode) fly.remove(); }, 1000);
    } catch(e){}
  }

  var styled = false;
  function style(){
    if (styled) return; styled = true;
    var s = document.createElement('style');
    s.textContent = '.ax-toast{position:fixed;left:50%;bottom:88px;transform:translateX(-50%) translateY(20px);z-index:2147483001;background:#E9EDF3;color:#0A1730;font-weight:700;font-size:.82rem;line-height:1;padding:13px 20px;border-radius:40px;box-shadow:0 14px 34px rgba(0,0,0,.35);opacity:0;transition:opacity .3s ease,transform .3s ease;max-width:calc(100vw - 24px);display:inline-flex;align-items:center;flex-wrap:nowrap;gap:12px;white-space:nowrap}.ax-toast>*{flex:0 0 auto;white-space:nowrap}.ax-toast.on{opacity:1;transform:translateX(-50%) translateY(0)}.ax-toast .ic{display:grid;place-items:center;width:19px;height:19px;border-radius:50%;background:#1FA855}.ax-toast .ic svg{width:11px;height:11px;fill:none;stroke:#fff;stroke-width:3.2;stroke-linecap:round;stroke-linejoin:round}.ax-toast .ms{letter-spacing:.01em}.ax-toast a{color:#0A1730;font-weight:800;letter-spacing:.07em;font-size:.72rem;text-decoration:none;border-left:1px solid rgba(10,23,48,.2);padding-left:12px}.ax-toast a:hover{color:#000}@media(max-width:359px){.ax-toast{font-size:.75rem;padding:12px 16px;gap:9px}}@media(min-width:750px){.ax-toast{bottom:26px}}';
    document.head.appendChild(s);
  }
  function toast(msg, linkText, linkHref){
    style();
    var t = document.createElement('div');
    t.className = 'ax-toast';
    t.setAttribute('role','status');
    var ic = document.createElement('span');
    ic.className = 'ic';
    ic.setAttribute('aria-hidden','true');
    ic.innerHTML = '<svg viewBox="0 0 24 24"><path d="M5 13l4 4L19 7"/></svg>';
    t.appendChild(ic);
    var sp = document.createElement('span');
    sp.className = 'ms';
    sp.textContent = msg;
    t.appendChild(sp);
    if (linkText && linkHref) {
      var a = document.createElement('a');
      a.href = linkHref;
      a.textContent = linkText;
      t.appendChild(a);
    }
    document.body.appendChild(t);
    requestAnimationFrame(function(){ t.classList.add('on'); });
    setTimeout(function(){ t.classList.remove('on'); setTimeout(function(){ t.remove(); }, 350); }, 3200);
  }

  /* outerHTML parses inside the live document, so <theme-drawer> and
     <cart-drawer-component> stay real custom elements. DOMParser does not. */
  function swapDrawer(data){
    try {
      var html = data && data.sections && data.sections[SEC];
      if (!html) return false;
      var wrap = document.getElementById(WRAP);
      if (!wrap) return false;
      wrap.outerHTML = html;
      return true;
    } catch(e){ return false; }
  }

  /* Three ways in, in order of preference. None of them clicks anything -
     clicking the header bubble used to bubble up to its <a href="/cart">
     and navigate, which is why phones jumped to the cart page. */
  function openDrawer(){
    var td = document.getElementById('cart-drawer');
    if (!td) return false;
    try { if (typeof td.open === 'function') { td.open(); return true; } } catch(e){}
    try {
      var dlg = td.querySelector('dialog');
      if (dlg && typeof dlg.showModal === 'function') { if (!dlg.open) dlg.showModal(); return true; }
    } catch(e){}
    try { td.setAttribute('open',''); return true; } catch(e){}
    return false;
  }

  function setCount(n){
    try {
      var els = document.querySelectorAll(COUNTS);
      for (var i=0;i<els.length;i++){
        if (els[i].firstElementChild) continue;
        if (/^\s*\d*\s*$/.test(els[i].textContent)) els[i].textContent = n;
      }
      var vis = document.querySelectorAll(BUBBLES);
      for (var v=0;v<vis.length;v++){
        vis[v].removeAttribute('hidden');
        if (n > 0) { vis[v].classList.remove('visually-hidden'); vis[v].classList.remove('hidden'); }
      }
      var ci = document.querySelectorAll('cart-icon');
      for (var c=0;c<ci.length;c++){
        if (n > 0) ci[c].classList.add('header-actions__cart-icon--has-cart');
        else ci[c].classList.remove('header-actions__cart-icon--has-cart');
      }
      var nav = q('.axbn a[href="/cart"]');
      if (nav) {
        var b = nav.querySelector('.cnt');
        if (n > 0) {
          if (!b) {
            b = document.createElement('span');
            b.className = 'cnt';
            nav.insertBefore(b, nav.firstChild ? nav.firstChild.nextSibling : null);
          }
          b.textContent = n;
        } else if (b) { b.remove(); }
      }
    } catch(e){}
  }

  function refreshCount(){
    return fetch('/cart.js', { credentials:'same-origin', headers:{'Accept':'application/json'} })
      .then(function(r){ return r.json(); })
      .then(function(c){ if (c && typeof c.item_count === 'number') setCount(c.item_count); })
      .catch(function(){});
  }

  document.addEventListener('click', function(e){
    var btn = e.target && e.target.closest ? e.target.closest('[data-ax-add]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.dataset.busy === '1') return;
    btn.dataset.busy = '1';

    var lbl = btn.querySelector('.lbl');
    var original = lbl ? lbl.textContent : '';
    spin(btn);
    flyToCart(btn);

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(btn.dataset.axAdd), quantity: 1 }],
        sections: SEC,
        sections_url: window.location.pathname
      })
    })
    .then(function(r){ if (!r.ok) throw new Error('add failed'); return r.json(); })
    .then(function(data){
      swapDrawer(data);
      unspin(btn);
      if (lbl) lbl.textContent = 'ADDED';

      try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles:true })); } catch(e){}
      try { document.dispatchEvent(new CustomEvent('cart:update',  { bubbles:true })); } catch(e){}

      refreshCount();

      /* the /cart page has no drawer at all - refresh so the list updates */
      if (onCartPage()) { window.location.reload(); return; }

      /* On a phone the drawer is full height, so opening it reads as "the site
         jumped to the cart page". Phones get a toast and a live cart count
         instead; the drawer markup is already refreshed underneath, so it is
         correct the moment they choose to open it. */
      var opened = false;
      if (!phone()) opened = openDrawer();
      if (!opened) toast('Added to cart', 'VIEW CART', '/cart');

      setTimeout(function(){
        if (lbl) lbl.textContent = original;
        btn.dataset.busy = '0';
      }, 1300);
    })
    .catch(function(){
      unspin(btn);
      if (lbl) lbl.textContent = original;
      btn.dataset.busy = '0';
      toast('Could not add that. Please try again.');
    });
  }, true);

  /* ---------- clear a discount code stuck on the cart ----------
     Adding ?axclear=1 to any URL wipes every code held on the cart.
     Invisible to shoppers, and the only way back once the cart's own
     discount UI was removed. */
  function clearDiscount(){
    try {
      if ((window.location.search || '').indexOf('axclear') === -1) return;
      fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
        body: JSON.stringify({ discount: '' })
      }).then(function(){
        window.location.replace(window.location.pathname);
      }).catch(function(){
        window.location.replace(window.location.pathname);
      });
    } catch(e){}
  }

  /* ---------- newsletter field: readable text + clear placeholder ---------- */
  var nlDone = false;
  function newsletter(){
    if (nlDone) return; nlDone = true;
    var s = document.createElement('style');
    s.textContent = '.ax-nl input,.axf input,input[name="contact[email]"]{color:#111827 !important;-webkit-text-fill-color:#111827 !important;caret-color:#0A1730 !important;font-size:.95rem !important}' +
      '.ax-nl input::placeholder,.axf input::placeholder,input[name="contact[email]"]::placeholder{color:#7A869C !important;-webkit-text-fill-color:#7A869C !important;opacity:1 !important}' +
      '.ax-nl input:-webkit-autofill,.axf input:-webkit-autofill{-webkit-text-fill-color:#111827 !important;box-shadow:0 0 0 1000px #fff inset !important}';
    document.head.appendChild(s);
    var ins = document.querySelectorAll('input[name="contact[email]"], .ax-nl input[type="email"], .axf input[type="email"]');
    for (var i=0;i<ins.length;i++){
      ins[i].placeholder = 'Enter your email address';
      ins[i].setAttribute('aria-label','Enter your email address');
    }
  }
  function nlNotice(){
    try {
      var s = window.location.search || '';
      if (s.indexOf('customer_posted=true') > -1) {
        toast('Thank you! You are on the ZAKDOR list.');
        if (window.history && history.replaceState) history.replaceState({}, '', window.location.pathname);
      }
    } catch(e){}
  }
  /* ---------- keep every cart badge live, whatever changed the cart ----------
     The delegated [data-ax-add] handler above only covers our own card
     buttons. A product page uses the theme's own add-to-cart form, and the
     drawer has its own +/- controls. Watching fetch catches all of them, so
     the bottom-nav count moves the instant the cart does. */
  var cnT = null;
  function bump(){ clearTimeout(cnT); cnT = setTimeout(refreshCount, 120); }
  window.axBump = bump;
  function watchCart(){
    var evs = ['cart:refresh','cart:update','shopify:cart:lines-update','shopify:section:load','theme-drawer:open'];
    for (var i=0;i<evs.length;i++) document.addEventListener(evs[i], bump);
    try {
      var of = window.fetch;
      if (typeof of === 'function' && !of.__ax) {
        var pf = function(){
          var u = '';
          try { var a = arguments[0]; u = (typeof a === 'string') ? a : (a && a.url) ? a.url : ''; } catch(e){}
          var r = of.apply(this, arguments);
          if (u && /\/cart\/(add|change|update|clear)/.test(u)) {
            try { r.then(bump, function(){}); } catch(e){}
          }
          return r;
        };
        pf.__ax = 1;
        window.fetch = pf;
      }
    } catch(e){}
    window.addEventListener('pageshow', bump);
  }

  function boot(){ clearDiscount(); newsletter(); nlNotice(); watchCart(); bump(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();